<div class="portal-example-page">
  <div class="portal-example-pager__content">
    <div class="d-back d-lg-none">
      <a class="p-3 d-lg-none" (click)="goToPreviousPage()" href="javascript:void(0)">
        <img src="../../../../../assets/images/JMicons/JM-icon-16.png" alt="back">GO BACK</a>
    </div>
    <p class="portal-top-text">
      View details of the health check
    </p>
    @if (apiHealthDetails) {
    <div class="example-container clearfix m-3 p-3">
      <div class="details">
        <div class="text-center p-4">
          @if (apiHealthDetails.code === HttpStatusCode.OK) {
          <img src="assets/images/JMicons/JM-icon-17.png" alt="icon">
          }
          @if (apiHealthDetails.code !== HttpStatusCode.OK) {
          <img src="assets/images/JMicons/JM-icon-18.png" alt="icon">
          }
        </div>
        <h2 class="text-center">{{ apiName }}</h2>
        <zing-grid class="mt-4" [data]="apiHealthDetails.checks ?? []" [tableSettings]="columnSettings"
          [masterSettings]="masterSettings" [dataKey]="'name'">
          <ng-template zingCustomColumn columnName="quota" let-hc>
            <div [ngClass]="{'quota-low':hc.status !== HealthCheckApiStatus.Healthy}">{{ hc.quota }}</div>
          </ng-template>
        </zing-grid>
        <!-- Identity Provider Probe Section -->
        @if (identityProviderCheck; as idp) {
        <div class="ip-probe outlined-box m-top-1">

          <p class="ip-probe__header fx-align-space-between-center fx-layout-row font-18">
            Identity Provider Probe
            <span class="ip-probe__status font-12" [class.healthy]="idp.isHealthy"
              [class.unhealthy]="!idp.isHealthy">
              {{ idp.isHealthy ? 'Healthy' : 'Unhealthy' }}
            </span>
          </p>

          <div class="ip-probe__meta font-13">
            <div class="ip-probe__meta-item fx-layout-column">
              <label class="light-text font-12">Mode</label>
              <span>{{ idp.mode }}</span>
            </div>
            <div class="ip-probe__meta-item fx-layout-column">
              <label class="light-text font-12">Auth schemes registered</label>
              <span>{{ idp.areAuthSchemesRegistered }}</span>
            </div>
            <div class="ip-probe__meta-item fx-layout-column">
              <label class="light-text font-12">Default authenticate scheme</label>
              <span>{{ idp.defaultAuthenticateScheme }}</span>
            </div>
            <div class="ip-probe__meta-item fx-layout-column">
              <label class="light-text font-12">Default challenge scheme</label>
              <span>{{ idp.defaultChallengeScheme }}</span>
            </div>
            <div class="ip-probe__meta-item fx-layout-column">
              <label class="light-text font-12">Checked at (UTC)</label>
              <span>{{ idp.checkedAtUtc | date:'medium' }}</span>
            </div>
            <div class="ip-probe__meta-item fx-layout-column">
              <label class="light-text font-12">Cache TTL (s)</label>
              <span>
                {{ idp.cacheTtlSeconds }}
                @if (idp.isStale) {
                <span class="ip-probe__stale font-12">Stale</span>
                }
              </span>
            </div>
          </div>
          @if (idp.isProbeSkipped) {
          <div class="ip-probe__skip-reason font-13">
            Probe skipped: {{ idp.probeSkipReason }}
          </div>
          }
          @if (idp.providers?.length > 0) {
          <h3>Provider Probes</h3>
          @for (p of idp.providers; track p) {
          <div class="ip-probe__provider outlined-box font-13"
            [class.healthy]="p.status === 'Available'"
            [class.unhealthy]="p.status === 'NotAvailable'"
            [class.unknown]="p.status === 'Unknown'">
            <div class="ip-probe__provider-header fx-align-space-between-center fx-layout-row">
              <span class="ip-probe__provider-name font-14 fw-#6">{{ p.provider }}</span>
              <span class="ip-probe__provider-status font-12"
                [class.healthy]="p.status === 'Available'"
                [class.unhealthy]="p.status === 'NotAvailable'"
                [class.unknown]="p.status === 'Unknown'">
                {{ p.status }}{{ p.httpStatusCode ? ' (' + p.httpStatusCode + ')' : '' }}
              </span>
            </div>
            <div class="ip-probe__provider-meta font-12 light-text">{{ p.authority }}</div>
            <div class="ip-probe__provider-meta font-12 light-text">{{ p.openIdConfigurationUrl }}</div>
            @if (p.error) {
            <div class="ip-probe__provider-error font-12">{{ p.error }}</div>
            }
          </div>
          }
          } @else {
          <p class="ip-probe__no-providers portal-font-italic light-text font-13">No provider probes were executed.</p>
          }
        </div>
        }
        <div class="float-right mt-4">
          <button class="footer-button" mat-raised-button color="primary" (click)="goToPreviousPage()">Back</button>
        </div>
      </div>
    </div>
    }
  </div>
</div>
<app-in-progress [loading]="loadingData"></app-in-progress>